import React, { ReactElement, useState } from "react";
import { StepProps } from "../TradeModal";
import styles from "./TermsAcceptance.module.scss";
import Link from "next/link";
import DisclaimerText from "components/DisclaimerText/DisclaimerText";
import Button from "components/core/Button/Button";

export default function TermsAcceptance(props: StepProps): ReactElement {
  props.setTitle("Terms of Trading on TiiCKER");

  const [hasAgreed, setHasAgreed] = useState(false);

  return (
    <div className={styles.termsOfTrading}>
      <DisclaimerText>
        <p className={styles.termsText}>
          By clicking your brokerage on the next step, you acknowledge your
          understanding and agreement that: (a) you are choosing to leave
          TiiCKER’s site; (b) TiiCKER has not encouraged your decision to
          purchase, sell, or hold any stock or security; (c) no TiiCKER
          representative has made any securities-related recommendations to you
          regarding your decision to leave TiiCKER’s site and/or to buy, sell,
          or hold any security via your brokerage account; (d) if you buy or
          sell shares via your brokerage account, you will not be directly
          charged by TiiCKER for any transaction or trading costs or fees; (e)
          your brokerage may share personally identifiable information and other
          information about you and your securities transaction with TiiCKER, in
          accordance with our{" "}
          <Link href="/privacy-policy">
            <a>Terms of Service</a>
          </Link>{" "}
          to better serve your future TiiCKER needs. You understand and agree
          that you are solely responsible for your decisions related to the
          purchase, sale, or holding of stocks or securities and that you are
          not purchasing, nor can you purchase, any securities through TiiCKER.
        </p>
      </DisclaimerText>
      <input
        type="checkbox"
        name="agreeToTerms"
        onChange={() => setHasAgreed(!hasAgreed)}
        checked={hasAgreed}
      />
      <label className={styles.agree}>
        {" "}
        I have read and agree to the above terms.{" "}
      </label>

      <div className={styles.buttonContainer}>
        <Button
          disabled={!hasAgreed}
          data-cy="accept-trading-terms-button"
          onClick={() => props.dispatch({ type: "acceptedTerms" })}
        >
          Continue
        </Button>
      </div>
    </div>
  );
}
